module.exports = __webpack_public_path__ + "static/media/mobile_icon.ff850303.svg";